<template>
    <div>
        <b-modal id="" ref="delete" centered hide-footer hide-header modal-class="del-member" content-class="modal-width">
            <div class="delete-member text-center">
                <img src="@/assets/admin/icon/warning.png" alt="">
                <h5>Xóa tài khoản khách mời</h5>
                <p>Bạn đang yêu cầu xóa bỏ tài khoản khách mời<br/>Sau khi xác nhận xóa bỏ sẽ không thể hoàn tác</p>
                <b-button class="mt-3 mr-3 btn-cancel" @click="hideModal()" block>Hủy bỏ</b-button>
                <b-button class="mt-3" block @click="deleteBlank">Xác nhận</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props:['del_id'],
    data() {
        return {
            data: this.del_id
        }
    },
    computed: {

    },
    methods: {
        show() {
            this.$refs['delete'].show()
        },
        hideModal() {
            this.$refs['delete'].hide()
        },
        emitModalVisible(isClose = false) {
            this.$emit("handleCloseModal", isClose);
        },
        async deleteBlank() {
            const data = {
                'member_id': this.del_id
            }
            const storedData = localStorage.getItem('admInfo')
            if (storedData) {
                var info = JSON.parse(storedData)
            }

            await this.$axios.put('/member/deleteBlankMember', data, {
                headers: {
                    'x-access-token': info.accessToken
                } 
            }).then((res) => {
                this.emitModalVisible(false)
                this.$toast.success('Xóa tài khoản thành công!')
                this.$refs['delete'].hide()
            }).catch((err) => {
                this.$toast.error(err)
            })
        }
    }
}
</script>

<style>
    .del-member .modal-width {
        width: 380px;
    }
</style>
<style lang="css" scoped>

    .delete-member h5,
    .delete-member p {
        color: #444444;
    }
    .delete-member button {
        background-color: #EE3439;
        color: #ffffff;
        font-weight: 500;
        border-radius: 10px;
        border: none;
        min-width: 163px;
        min-height: 42px;
    }

    .delete-member button:active,
    .delete-member button:focus {
        background-color: #EE3439 !important;
    }

    .delete-member button:hover {
        background-color: #EE3439;
    }

    .delete-member .btn-cancel {
        color: #EE3439;
        border: 1px solid #EE3439;
        background: #ffffff;
    }

    .delete-member .btn-cancel:hover,
    .delete-member .btn-cancel:focus,
    .delete-member .btn-cancel:active {
        background: #ffffff !important;
        color: #EE3439;
        border: 1px solid #EE3439;
    }
    @media (max-width: 375px) {
        .delete-member .btn-cancel {
            margin-right: 0 !important;
        }

        .delete-member p {
            font-size: 15px;
        }
    }
</style>